// DataTableContext.tsx
import React, { createContext, useContext } from 'react';
import { useDataTable } from '../Hooks/useDataTable'; // <- le hook que tu as fourni
import { DataTableConfig } from '@/Shared/Types/datatable.types';

type DataTableContextValue<VM extends Record<string, any>> = ReturnType<typeof useDataTable<VM>>;

//const DataTableContext = createContext<DataTableContextValue<any> | undefined>(undefined);

const DataTableContext = createContext<any>(undefined);

export function DataTableProvider<VM extends Record<string, any>>({ config, children }: {
    config: DataTableConfig<VM>,
    children: React.ReactNode
}) {
    const value = useDataTable<VM>(config);

    
    return (
        <DataTableContext.Provider value={value} >
            {children}
        </DataTableContext.Provider>
    );
}

// Hook pour accéder au contexte
export function useDataTableContext<VM extends Record<string, any>>() {
    const context = useContext(DataTableContext);
    if (!context) {
        throw new Error('useDataTableContext must be used within a DataTableProvider');
    }
    return context as DataTableContextValue<VM>;
}
